import { useMemo, useState } from 'react'

export const usePaginacion = (listaItems, itemsPorPaginaInicial) => {
  const [paginaActual, setPaginaActual] = useState(1)
  const [itemsPorPagina, setItemsPorPagina] = useState(itemsPorPaginaInicial)

  const totalPaginas = useMemo(
    () => Math.max(1, Math.ceil((listaItems?.length ?? 0) / itemsPorPagina)),
    [listaItems, itemsPorPagina]
  )

  const itemsActual = useMemo(() => {
    if (!listaItems?.length) return []
    const indiceUltimo = paginaActual * itemsPorPagina
    const indicePrimero = indiceUltimo - itemsPorPagina
    return listaItems.slice(indicePrimero, indiceUltimo)
  }, [listaItems, paginaActual, itemsPorPagina])

  return {
    itemsActual,
    paginaActual,
    setPaginaActual,
    itemsPorPagina,
    setItemsPorPagina,
    totalPaginas
  }
}
